// import React from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { Box, Typography } from "@mui/material";
// import { ChevronLeft, Star } from "lucide-react";

// const DedicatedReview = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { product } = location.state || {};


//   if (!product) {
//     return <p>No product data. Please go back.</p>;
//   }

//   const ratingBreakdown = [
//     { stars: 5, percent: product.rate_5_percent },
//     { stars: 4, percent: product.rate_4_percent },
//     { stars: 3, percent: product.rate_3_percent },
//     { stars: 2, percent: product.rate_2_percent },
//     { stars: 1, percent: product.rate_1_percent },
//   ];


//   return (
//     <div className="max-w-[1500px] mx-auto my-5 p-2">
//       {/* Back Button */}
//       <Typography
//         sx={{
//           mb: 2,
//           cursor: "pointer",
//           color: "#8d8c8c",
//           display: "flex",
//           alignItems: "center",
//         }}
//         onClick={() => navigate(-1)}
//       >
//         <ChevronLeft size={20} /> Back to Product
//       </Typography>

//       {/* Product Info */}
//       <Box
//         sx={{
//           mb: 4,
//         }}
//       >
//         <h1 className="text-2xl mb-2">Product Reviews</h1>
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: { xs: "column", md: "row" },
//             gap: 2,
//           }}
//         >
//           {/* Product Card */}
//           <Box
//             sx={{
//               bgcolor: "white",
//               border: "1px solid #eee",
//               borderRadius: 2,
//               p: 2,
//               // width: { xs: "100%", md: 1000 },
//               display: "flex",
//               flexDirection: { xs: "column" },
//               gap: 2,
//             }}
//           >
//             <Box
//               component="img"
//               src={product.inventory?.[0]?.images?.[0]?.img || ""}
//               alt={product.title || "Product"}
//               sx={{
//                 width: { xs: "200px", sm: "220px" }, // fixed width (responsive)
//                 height: { xs: "200px", sm: "220px" }, // fixed height (responsive)
//                 borderRadius: 2,
//                 objectFit: "cover", // crop edges to fit box
//                 objectPosition: "center", // keep center part visible
//               }}
//             />

//             <h4 className="text-2xl text-center truncate">{product.title}</h4>
//           </Box>
//           {/* Rating Breakdown */}
//           <Box
//             flex={1}
//             sx={{
//               bgcolor: "white",
//               border: "1px solid #eee",
//               borderRadius: 2,
//               p: 2,
//               minWidth: { xs: "100%", md: 300 },
//               maxWidth: 500,
//             }}
//           >
//             <Typography
//               variant="h6"
//               sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}
//             >
//               <Box
//                 component="span"
//                 sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
//               >
//                 {Math.round(product.rating || 0)}{" "}
//                 <Star fill="#FACC15" size={18} style={{ color: "#FACC15" }} />
//                 {/* {console.log(product, "i am product")} */}
//               </Box>
//               Reviews from people
//             </Typography>

//             {ratingBreakdown.map((r) => (
//               <Box
//                 key={r.stars}
//                 display="flex"
//                 alignItems="center"
//                 sx={{ mb: 2.5 }}
//               >
//                 <Typography sx={{ width: 50 }}>{r.stars} Star</Typography>
//                 <Box
//                   sx={{
//                     flex: 1,
//                     height: 25,
//                     border: "1px solid #e0e0e0",
//                     borderRadius: 1,
//                     overflow: "hidden",
//                     ml: 1,
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       height: "100%",
//                       width: `${r.percent}%`,
//                       bgcolor: "#FACC15",
//                     }}
//                   />
//                 </Box>
//                 <Typography sx={{ ml: 1 }}>{r.percent}%</Typography>
//               </Box>
//             ))}
//           </Box>
//         </Box>
//       </Box>
//       {/* Reviews List */}
//       <Typography variant="h6" sx={{ mb: 2 }}>
//         Reviews
//       </Typography>

//       {product.product_content_reviews?.map((review) => (
//         <Box key={review.id} sx={{ borderRadius: 2, p: 2, mb: 2 }}>

//           <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
//             {Array.from({ length: 5 }).map((_, index) => {
//               const reviewStars = () => {
//                 if (review?.rate1 === 1) {
//                   return 1;
//                 }
//                 if (review?.rate2 === 1) {
//                   return 2;
//                 }
//                 if (review?.rate3 === 1) {
//                   return 3;
//                 }
//                 if (review?.rate4 === 1) {
//                   return 4;
//                 }
//                 if (review?.rate5 === 1) {
//                   return 5;
//                 }
//               };
//               return (
//                 <Star
//                   key={index}
//                   style={{
//                     color: index < reviewStars() ? "#FACC15" : "#ccc",
//                     fill: index < reviewStars() ? "#FACC15" : "none", // 🔑 fill color
//                     fontSize: 22,
//                   }}
//                 />
//               );
//             })}
//           </Box>

//           <Typography>{review.text}</Typography>

//           {review.img?.length > 0 && (
//             <Box display="flex" gap={1} sx={{ mt: 1, flexWrap: "wrap" }}>
//               {review.img.map((image) => (
//                 <Box
//                   key={image.id}
//                   component="img"
//                   src={image.img}
//                   alt="review"
//                   sx={{
//                     width: 70,
//                     height: 80,
//                     objectFit: "cover",
//                     borderRadius: 2,
//                     border: "1px solid #ddd",
//                   }}
//                 />
//               ))}
//             </Box>
//           )}
//         </Box>
//       ))}
//     </div>
//   );
// };

// export default DedicatedReview;

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft, Star } from "lucide-react";

const DedicatedReview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { product } = location.state || {};

  if (!product) {
    return (
      <div className="p-6 text-center text-gray-500">
        No product data. Please go back.
      </div>
    );
  }

  const ratingBreakdown = [
    { stars: 5, percent: product.rate_5_percent },
    { stars: 4, percent: product.rate_4_percent },
    { stars: 3, percent: product.rate_3_percent },
    { stars: 2, percent: product.rate_2_percent },
    { stars: 1, percent: product.rate_1_percent },
  ];

  const getReviewStars = (review) => {
    if (review?.rate1 === 1) return 1;
    if (review?.rate2 === 1) return 2;
    if (review?.rate3 === 1) return 3;
    if (review?.rate4 === 1) return 4;
    if (review?.rate5 === 1) return 5;
    return 0;
  };

  return (
    <div className="bg-[#F8FAFC]">
    
    <div className="max-w-6xl mx-auto px-4 py-8">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-500 hover:text-black transition mb-6 sticky top-0"
      >
        <ChevronLeft size={18} />
        Back to Product
      </button>

      {/* Header Section */}
      <h1 className="text-3xl font-semibold mb-6">Product Reviews</h1>

      <div className="grid md:grid-cols-2 gap-6 mb-10">
        {/* Product Card */}
        <div className="bg-white rounded-xl border p-6 flex flex-col items-center text-center">
          <img
            src={product.inventory?.[0]?.images?.[0]?.img || ""}
            alt={product.title}
            className="w-56 h-56 object-cover rounded-xl mb-4"
          />
          <h2 className="text-xl font-medium">{product.title}</h2>
        </div>

        {/* Rating Breakdown */}
        <div className="bg-white rounded-xl border p-6">
          <div className="flex items-center gap-2 mb-6">
            <span className="text-2xl font-semibold">
              {Math.round(product.rating || 0)}
            </span>
            <Star size={20} className="text-yellow-400 fill-yellow-400" />
            <span className="text-gray-500">Reviews from people</span>
          </div>

          {ratingBreakdown.map((r) => (
            <div key={r.stars} className="flex items-center gap-3 mb-4">
              <span className="w-12 text-sm text-gray-600">
                {r.stars} Star
              </span>

              <div className="flex-1 bg-gray-100 rounded-full h-4 overflow-hidden">
                <div
                  className="bg-yellow-400 h-full rounded-full transition-all duration-500"
                  style={{ width: `${r.percent}%` }}
                />
              </div>

              <span className="text-sm text-gray-500 w-10 text-right">
                {r.percent}%
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Reviews Section */}
      <h2 className="text-xl font-semibold mb-6">Customer Reviews</h2>

      <div className="space-y-6">
        {product.product_content_reviews?.map((review) => {
          const stars = getReviewStars(review);

          return (
            <div
              key={review.id}
              className="bg-white border rounded-xl p-6"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, index) => (
                  <Star
                    key={index}
                    size={20}
                    className={
                      index < stars
                        ? "text-yellow-400 fill-yellow-400"
                        : "text-gray-300"
                    }
                  />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-700 leading-relaxed mb-4">
                {review.text}
              </p>

              {/* Review Images */}
              {review.img?.length > 0 && (
                <div className="flex gap-3 flex-wrap">
                  {review.img.map((image) => (
                    <img
                      key={image.id}
                      src={image.img}
                      alt="review"
                      className="w-20 h-20 object-cover rounded-lg border hover:scale-105 transition"
                    />
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
    </div>
  );
};

export default DedicatedReview;

